import type { FaireProductEntity } from "../../entity_types/product";

export const p_4qzqmsur49: FaireProductEntity = {
  token: "p_4qzqmsur49",
  type: "product",
  name: "Brass Altar Bell Om 3 inch",
  brandToken: "b_pfe5z89pnk",
  brandName: "Vrinda",
  imageUrl:
    "https://cdn.faire.com/fastly/1c6fc2ccc0e50489f4f02d4b5bce0cae078712d2eed8ac5ec5cf820477f08bc8.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/03b10a9eb0163af0217794862a06c096183c3606f4c745c7c5a9409edb2456e0.jpeg",
    "https://cdn.faire.com/fastly/80e8c461bab7ada382103e7c0c0b163f825183870e2c5db2d83f20cac5e39cc2.jpeg",
  ],
  priceDollars: 3.12,
  description:
    "Our Vrinda Brass Altar Bell, adorned with an Om design, stands about 3'' high. This unique piece is more than just a bell; it's a tool for mindfulness and spiritual connection. Whether placed in your home, it serves as a reminder of balance and peace. This bell's resonating sound aids in healing and meditation, complementing our premium range of wellness products. Use it to enhance your sacred living space and encourage well-being.",
  tags: [],
  msrpDollars: 6.24,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:54:56.032Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
